var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11652_13712)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 16,
    rx: 0.5,
    transform: "matrix(1.19249e-08 1 1 -1.19249e-08 0.666748 0)",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35681 3C6.18075 3 5.25855 4.00984 5.36503 5.18107L6.00139 12.1811C6.09504 13.2112 6.95877 14 7.99318 14L9.34032 14C10.3747 14 11.2385 13.2112 11.3321 12.1811L11.9685 5.18107C12.0749 4.00984 11.1527 3 9.97668 3L7.35681 3Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11652_13712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "matrix(1.19249e-08 1 1 -1.19249e-08 0.666748 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignTop);
export default __webpack_public_path__ + "static/media/alignTop.47934fa489e41cfe22ceb35f580565fb.svg";
export { ForwardRef as ReactComponent };